import { createSelector } from '@ngrx/store';
import { selectPayeeDetailModuleState } from './selector';

export const payrollSettingsSelector = createSelector(selectPayeeDetailModuleState, (state) => state?.payrollSettings);

export const getPayrollSettingsSelector = createSelector(payrollSettingsSelector, (state) => state?.getPayrollSettings);
